import { useState } from "react";
import { createPortal } from "react-dom";
import { styled } from "styled-components";
import { lang } from "../assets/languages/en.language";
import { theme } from "../configs/theme";
import { Flex } from "../styles/Utils";
import Popup from "./Popup.component";
import { CheckMarkIcon } from "./svgs/icons/CheckMark.icon";

export default function StatusBadge() {
  const [displayStatutBadgeInfo, setDisplayStatutBadgeInfo] = useState<boolean>(false);

  return (
    <>
      {displayStatutBadgeInfo &&
        // Use createPortal to render the popup in document.body,
        // avoiding stacking issues caused by z-index in parent components.
        createPortal(
          <Popup
            type="info"
            title={lang.swiperPage.statutBadgeInfo.title}
            message={lang.swiperPage.statutBadgeInfo.message}
            buttonText={lang.swiperPage.statutBadgeInfo.buttonText}
            Icon={CheckMarkIcon}
            action={() => {
              setDisplayStatutBadgeInfo(false);
            }}
            onClose={() => {
              setDisplayStatutBadgeInfo(false);
            }}
          />,
          document.body
        )}
      <RootContainer onClick={() => setDisplayStatutBadgeInfo(true)}>
        <CheckMarkIcon color={theme.color.tertiaryLight} />
      </RootContainer>
    </>
  );
}

const RootContainer = styled(Flex)`
  width: 4rem;
  height: 4rem;
  background-color: ${(props) => props.theme.color.success};
  justify-content: center;
  border-radius: 100px;
  padding: 1rem;
  > svg {
    height: 100%;
  }
`;
